export function getWindow() {
  // @ts-ignore returning window object
  return window;
}